import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot, Routes, CanActivate } from '@angular/router';

import { UserRouteAccessService } from '../../shared';
import { PaginationUtil } from 'ng-jhipster';

import { ReservationCancellationReasonComponent } from './reservation-cancellation-reason.component';
import { ReservationCancellationReasonDetailComponent } from './reservation-cancellation-reason-detail.component';
import { ReservationCancellationReasonPopupComponent } from './reservation-cancellation-reason-dialog.component';
import { ReservationCancellationReasonDeletePopupComponent }
    from './reservation-cancellation-reason-delete-dialog.component';

import { Principal } from '../../shared';

@Injectable()
export class ReservationCancellationReasonResolvePagingParams implements Resolve<any> {

    constructor(private paginationUtil: PaginationUtil) { }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        let page = route.queryParams['page'] ? route.queryParams['page'] : '1';
        let sort = route.queryParams['sort'] ? route.queryParams['sort'] : 'id,asc';
        return {
            page: this.paginationUtil.parsePage(page),
            predicate: this.paginationUtil.parsePredicate(sort),
            ascending: this.paginationUtil.parseAscending(sort)
        };
    }
}

export const reservationCancellationReasonRoute: Routes = [
    {
        path: 'reservation-cancellation-reason',
        component: ReservationCancellationReasonComponent,
        resolve: {
            'pagingParams': ReservationCancellationReasonResolvePagingParams
        },
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'jYoguiApp.reservationCancellationReason.home.title'
        }
    }, {
        path: 'reservation-cancellation-reason/:id',
        component: ReservationCancellationReasonDetailComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'jYoguiApp.reservationCancellationReason.home.title'
        }
    }
];

export const reservationCancellationReasonPopupRoute: Routes = [
    {
        path: 'reservation-cancellation-reason-new',
        component: ReservationCancellationReasonPopupComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'jYoguiApp.reservationCancellationReason.home.title'
        },
        outlet: 'popup'
    },
    {
        path: 'reservation-cancellation-reason/:id/edit',
        component: ReservationCancellationReasonPopupComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'jYoguiApp.reservationCancellationReason.home.title'
        },
        outlet: 'popup'
    },
    {
        path: 'reservation-cancellation-reason/:id/delete',
        component: ReservationCancellationReasonDeletePopupComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'jYoguiApp.reservationCancellationReason.home.title'
        },
        outlet: 'popup'
    }
];



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/reservation-cancellation-reason/reservation-cancellation-reason.route.ts